<template>
  <router-view></router-view>
</template>
<style>
#app {
  height: 100%;
  background:#F4F3FA;
}
body ,html {
  height: 100%;
  padding:0;
  margin:0;
  font: 14px Helvetica Neue,Helvetica,PingFang SC,Tahoma,Arial,sans-serif;
}
</style>
<script setup lang="ts">
</script>